(() => {
  const SELECTORS = {
    module: '[data-ra-vehicle-identification]',
    registration: '[data-ra-registration]',
    vin: '[data-ra-vin]',
    unknown: '[data-ra-vehicle-unknown]',
    error: '[data-ra-vehicle-error]',
    status: '[data-ra-vehicle-status]',
    checkout: '#checkout',
    cartForm: '#cart'
  };

  const ATTRIBUTE_NAMES = {
    registration: 'Immatriculation du véhicule',
    vin: 'VIN du véhicule',
    unknown: 'Identification véhicule indisponible'
  };

  let saveTimer = null;
  let checkoutInProgress = false;

  function getModule() {
    return document.querySelector(SELECTORS.module);
  }

  function cleanRegistration(value) {
    return value
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[^A-Z0-9-]/g, '')
      .slice(0, 12);
  }

  function formatRegistration(value) {
    const cleanValue = cleanRegistration(value);
    const alphanumericValue = cleanValue.replace(/-/g, '');

    if (/^[A-Z]{2}\d{3}[A-Z]{2}$/.test(alphanumericValue)) {
      return [
        alphanumericValue.slice(0, 2),
        alphanumericValue.slice(2, 5),
        alphanumericValue.slice(5, 7)
      ].join('-');
    }

    return cleanValue;
  }

  function cleanVin(value) {
    return value
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 17);
  }

  function getElements(module) {
    return {
      registration: module.querySelector(SELECTORS.registration),
      vin: module.querySelector(SELECTORS.vin),
      unknown: module.querySelector(SELECTORS.unknown),
      error: module.querySelector(SELECTORS.error),
      status: module.querySelector(SELECTORS.status)
    };
  }

  function getValues(module) {
    const elements = getElements(module);
    const unknown = Boolean(elements.unknown?.checked);

    return {
      registration: unknown
        ? ''
        : formatRegistration(elements.registration?.value || ''),
      vin: unknown
        ? ''
        : cleanVin(elements.vin?.value || ''),
      unknown
    };
  }

  function setStatus(module, message) {
    const status = module.querySelector(SELECTORS.status);

    if (status) {
      status.textContent = message;
    }
  }

  function hideError(module) {
    const error = module.querySelector(SELECTORS.error);

    module.classList.remove('is-invalid');

    if (error) {
      error.hidden = true;
    }
  }

  function showError(module) {
    const elements = getElements(module);

    module.classList.add('is-invalid');

    if (elements.error) {
      elements.error.hidden = false;
    }

    if (!elements.unknown?.checked) {
      elements.registration?.focus();

      module.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  function updateDisabledState(module) {
    const elements = getElements(module);
    const disabled = Boolean(elements.unknown?.checked);

    if (elements.registration) {
      elements.registration.disabled = disabled;
    }

    if (elements.vin) {
      elements.vin.disabled = disabled;
    }

    module.classList.toggle('is-disabled', disabled);
  }

  function isValidFrenchRegistration(value) {
  const registration = value
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/-/g, '');

  /*
   * Formats acceptés :
   * - SIV actuel : AB-123-CD
   * - Ancien format français : 1234 AB 56
   */
  const currentFormat = /^[A-Z]{2}\d{3}[A-Z]{2}$/;
  const oldFormat = /^\d{1,4}[A-Z]{1,3}\d{2,3}$/;

  return currentFormat.test(registration) || oldFormat.test(registration);
}

function isValidVin(value) {
  const vin = cleanVin(value);

  /*
   * Un VIN comporte 17 caractères.
   * Les lettres I, O et Q ne sont normalement pas utilisées,
   * afin d’éviter leur confusion avec 1 et 0.
   */
  return /^[A-HJ-NPR-Z0-9]{17}$/.test(vin);
}

function isValid(module) {
  const values = getValues(module);

  if (values.unknown) {
    return true;
  }

  if (values.registration && isValidFrenchRegistration(values.registration)) {
    return true;
  }

  if (values.vin && isValidVin(values.vin)) {
    return true;
  }

  return false;
}

  async function saveAttributes(module, showConfirmation = false) {
    const values = getValues(module);

    setStatus(module, 'Enregistrement…');

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [ATTRIBUTE_NAMES.registration]: values.registration,
            [ATTRIBUTE_NAMES.vin]: values.vin,
            [ATTRIBUTE_NAMES.unknown]: values.unknown ? 'Oui' : ''
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        `Erreur d’enregistrement du véhicule : ${response.status}`
      );
    }

    if (showConfirmation) {
      setStatus(module, 'Informations enregistrées.');
    } else {
      setStatus(module, '');
    }

    return response.json();
  }

  function scheduleSave(module) {
    window.clearTimeout(saveTimer);

    saveTimer = window.setTimeout(async () => {
      try {
        await saveAttributes(module, true);
      } catch (error) {
        console.error(error);
        setStatus(
          module,
          'Impossible d’enregistrer automatiquement les informations.'
        );
      }
    }, 500);
  }

  function initialiseModule(module) {
    if (module.dataset.raInitialised === 'true') {
      return;
    }

    module.dataset.raInitialised = 'true';

    const elements = getElements(module);

    if (elements.registration) {
      elements.registration.value = formatRegistration(
        elements.registration.value
      );
    }

    if (elements.vin) {
      elements.vin.value = cleanVin(elements.vin.value);
    }

    updateDisabledState(module);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const module = getModule();

    if (module) {
      initialiseModule(module);
    }
  });

  document.addEventListener('input', event => {
    const module = event.target.closest(SELECTORS.module);

    if (!module) {
      return;
    }

    hideError(module);

    if (event.target.matches(SELECTORS.registration)) {
      event.target.value = cleanRegistration(event.target.value);
      scheduleSave(module);
    }

    if (event.target.matches(SELECTORS.vin)) {
      event.target.value = cleanVin(event.target.value);
      scheduleSave(module);
    }
  });

  document.addEventListener('blur', event => {
    const module = event.target.closest?.(SELECTORS.module);

    if (!module) {
      return;
    }

    if (event.target.matches(SELECTORS.registration)) {
      event.target.value = formatRegistration(event.target.value);
      scheduleSave(module);
    }
  }, true);

  document.addEventListener('change', event => {
    const module = event.target.closest(SELECTORS.module);

    if (!module || !event.target.matches(SELECTORS.unknown)) {
      return;
    }

    hideError(module);
    updateDisabledState(module);
    scheduleSave(module);
  });

  document.addEventListener('click', async event => {
    const checkoutButton = event.target.closest(SELECTORS.checkout);

    if (!checkoutButton || checkoutInProgress) {
      return;
    }

    const module = getModule();
    const cartForm = document.querySelector(SELECTORS.cartForm);

    if (!module || !cartForm) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    hideError(module);

    if (!isValid(module)) {
      showError(module);
      return;
    }

    checkoutInProgress = true;
    checkoutButton.disabled = true;

    setStatus(module, 'Enregistrement avant le passage en caisse…');

    try {
      await saveAttributes(module);

      let checkoutInput = cartForm.querySelector(
        'input[name="checkout"][data-ra-checkout-input]'
      );

      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'checkout';
        checkoutInput.dataset.raCheckoutInput = 'true';

        cartForm.appendChild(checkoutInput);
      }

      cartForm.submit();
    } catch (error) {
      console.error(error);

      checkoutInProgress = false;
      checkoutButton.disabled = false;

      setStatus(
        module,
        'Une erreur est survenue. Veuillez réessayer avant de commander.'
      );
    }
  }, true);
})();